"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _tinymce = _interopRequireDefault(require("tinymce"));

var _plugins = require("../constants/plugins");

var _formatting = require("../utils/formatting");

var _utils = require("../hsformatting/utils");

var _dom = require("../utils/dom");

var DELETE_KEY_CODE = 8;
var blockNodes = ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'DIV', 'PRE', 'BR'];
/* 
Upon delete from the start of an <li>, delete up into the previous <li>
but on a newline and retains the indent: 
  1. alpha
  2. |beta
  3. gamma
---- 'DELETE' ---->
  1. alpha
     beta
  2. gamma
*/

var deleteIntoPrevLi = function deleteIntoPrevLi(editor, listNode, evt) {
  var prevListNode = listNode.previousSibling;
  if (!prevListNode) return;
  editor.undoManager.transact(function () {
    var content = listNode.innerHTML;
    editor.dom.remove(listNode);
    editor.selection.setCursorLocation(prevListNode, prevListNode.childNodes.length);

    if (!blockNodes.includes(prevListNode.lastChild.nodeName)) {
      editor.selection.setContent('<br>');
    }

    var bm = editor.selection.getBookmark();
    editor.selection.setContent(content);
    editor.selection.moveToBookmark(bm);
  });
  evt.preventDefault();
};
/*
Upon deleting from an empty <li> and then again from the indented trailing <br>
in the previous <li>, escape and/or split the larger list block:
  1. alpha
     |
  2. beta
---- 'DELETE' ---->
  1. alpha
  <p>|</p>
  1. beta
[-----------------]
  1. alpha
      1. beta
         |
  2. gamma
---- 'DELETE' ---->
  1. alpha
      1. beta
  <p>|</p>
  1. gamma
*/


var escapeListBlock = function escapeListBlock(editor, rng, evt) {
  var container = rng.startContainer;
  var node = container.childNodes[rng.startOffset];
  if (node.nodeName !== 'BR') return;
  var parentListBlocks = editor.dom.getParents(container, 'ul,ol', editor.getBody());
  if (!parentListBlocks) return;
  var outerParentBlock = parentListBlocks[parentListBlocks.length - 1];
  var newBlock = editor.dom.create(editor.settings.forced_root_block || 'p', {}, _dom.BOGUS_BR);
  editor.undoManager.transact(function () {
    if (!(0, _utils.isNestedLastChild)(container, outerParentBlock)) {
      var tmpRng = rng.cloneRange();
      var parentLiNodes = editor.dom.getParents(container, 'li', outerParentBlock);
      var nextSibling;
      parentLiNodes.forEach(function (liNode) {
        if (nextSibling) return;
        nextSibling = liNode.nextSibling;
      });
      tmpRng.setStartBefore(nextSibling);
      tmpRng.setEndAfter(outerParentBlock);
      var fragment = tmpRng.extractContents(); // Start of list fragment is a nested <li>, don't show list styles

      var firstLiNode = fragment.firstChild.firstChild;
      var hasListBlockAsChild = firstLiNode.childNodes.length === 1 && ['UL', 'OL'].includes(firstLiNode.firstChild.nodeName);

      while (hasListBlockAsChild) {
        firstLiNode.setAttribute('style', 'list-style-type: none;');
        firstLiNode = firstLiNode.firstChild.firstChild;
        hasListBlockAsChild = firstLiNode.childNodes.length === 1 && ['UL', 'OL'].includes(firstLiNode.firstChild.nodeName);
      }

      editor.dom.insertAfter(fragment, outerParentBlock);
    }

    if ((0, _utils.isFirstChild)(container) && container.childNodes.length === 1) {
      node = container;
    }

    editor.dom.remove(node);
    editor.dom.insertAfter(newBlock, outerParentBlock);

    if (!outerParentBlock.hasChildNodes()) {
      editor.dom.remove(outerParentBlock);
    }

    editor.selection.setCursorLocation(newBlock, 0);
  });
  evt.stopImmediatePropagation();
  evt.preventDefault();
};

var hslistsPlugin = function hslistsPlugin(editor) {
  editor.on('KeyDown', function (evt) {
    if (evt.keyCode !== DELETE_KEY_CODE || !editor.selection.isCollapsed()) return;
    var selectedListNode = (0, _formatting.getListNode)(editor, editor.selection.getNode());
    if (!selectedListNode) return;
    var rng = editor.selection.getRng();
    var container = rng.startContainer;

    if (rng.startOffset === 0 && (0, _utils.isNestedFirstChild)(container, selectedListNode)) {
      deleteIntoPrevLi(editor, selectedListNode, evt);
    } else if (selectedListNode === container && container.hasChildNodes() && rng.startOffset === container.childNodes.length - 1) {
      escapeListBlock(editor, rng, evt);
    }
  }, true);
};

_tinymce.default.PluginManager.add(_plugins.HS_LISTS, hslistsPlugin);